import { MedicalHistoryConditions } from "./MedicalHistoryConditions";
import { MedicalHistoryCurrentPregnancy } from "./MedicalHistoryCurrentPregnancy";
import { MedicalHistoryGeneticHistoryOfGametes } from "./MedicalHistoryGeneticHistoryOfGametes";
import { MedicalHistoryInfectiousDisease } from "./MedicalHistoryInfectiousDisease";
import { MedicalHistoryLifestyleAndSocial } from "./MedicalHistoryLifestyleAndSocial";
import { MedicalHistoryMentalHealthAndSubstanceUse } from "./MedicalHistoryMentalHealthAndSubstanceUse";
import { MedicalHistoryNutrition } from "./MedicalHistoryNutrition";

class OntarioObstetricalMedicalHistory {
    public CurrentPregnancy: MedicalHistoryCurrentPregnancy;
    public Nutrition: MedicalHistoryNutrition;
    public HadSurgery?: boolean;
    public HadAnaestheticComplications?: boolean;
    public HistoricalConditions: MedicalHistoryConditions;
    public HasFamilyHistoryOfMedicalConditions?: boolean;
    public GeneticHistoryOfGametes: MedicalHistoryGeneticHistoryOfGametes;
    public InfectiousDisease: MedicalHistoryInfectiousDisease;
    public MentalHealthAndSubstanceUse: MedicalHistoryMentalHealthAndSubstanceUse;
    public LifestyleAndSocial: MedicalHistoryLifestyleAndSocial;
    public Comments: string;

    constructor(fields?: Partial<OntarioObstetricalMedicalHistory>) {
        Object.assign(this, fields);
        this.CurrentPregnancy = new MedicalHistoryCurrentPregnancy(fields?.CurrentPregnancy);
        this.Nutrition = new MedicalHistoryNutrition(fields?.Nutrition);
        this.HistoricalConditions = new MedicalHistoryConditions(fields?.HistoricalConditions);
        this.GeneticHistoryOfGametes = new MedicalHistoryGeneticHistoryOfGametes(fields?.GeneticHistoryOfGametes);
        this.InfectiousDisease = new MedicalHistoryInfectiousDisease(fields?.InfectiousDisease);
        this.MentalHealthAndSubstanceUse = new MedicalHistoryMentalHealthAndSubstanceUse(fields?.MentalHealthAndSubstanceUse);
        this.LifestyleAndSocial = new MedicalHistoryLifestyleAndSocial(fields?.LifestyleAndSocial);
    }

    public setEmptyFieldsAsNo(): void {
        this.HadSurgery = this.HadSurgery || false;
        this.HadAnaestheticComplications = this.HadAnaestheticComplications || false;
        this.HasFamilyHistoryOfMedicalConditions = this.HasFamilyHistoryOfMedicalConditions || false;
        this.CurrentPregnancy.setEmptyFieldsAsNo();
        this.Nutrition.setEmptyFieldsAsNo();
        this.HistoricalConditions.setEmptyFieldsAsNo();
        this.GeneticHistoryOfGametes.setEmptyFieldsAsNo();
        this.InfectiousDisease.setEmptyFieldsAsNo();
        this.MentalHealthAndSubstanceUse.setEmptyFieldsAsNo();
        this.LifestyleAndSocial.setEmptyFieldsAsNo();
    }
}

export { OntarioObstetricalMedicalHistory };
